import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetUsersValue, UserLookup, Users } from '../models';

export const usersActions = createActionGroup({
    source: 'Users',
    events: {
        'Get Users': props<{ value: GetUsersValue }>(),
        'Get Users Success': props<{ payload: Users }>(),
        'Get Users Error': props<{ code: number }>(),

        'Get Users Lookup': emptyProps(),
        'Get Users Lookup Success': props<{ payload: UserLookup[] }>(),
        'Get Users Lookup Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
